import React, { Fragment } from "react";
import uuidv4 from "uuid/v4";
import { loaderSVG, BlockedIconHoc } from "../../../../assets/images";
import SDK from "../../../../SDK";
import _get from "lodash-es/get";	
import Modal from "../../Common/Modal";
import MessageInfo from "../MessageInfo/index.js";
import CustomIcon from "../../../../assets/images/CustomIcon";
import ForwardOptions from "./Templates/Common/ForwardOptions.js";
import ChatTemplate from "./Templates/ChatTemplate.js";
import WebChatMessagesComposing from "./WebChatMessagesComposing.js";
import {
  getActiveConversationUserJid,
  isSingleChat,
  getActiveConversationChatId,
  isSingleOrGroupChat,
  getChatMessageHistoryById,
  getActiveChatMessages,
  downloadMediaFile,
  isGroupChat,
  // handleTempArchivedChats,
  getActiveConversationMessageByMsgId,	
  getReplyMessageFormat,
  messageInfoAction,
  copyToClipboard,
  isTextMessage,
  getMessagesForReport,
  // getActiveConversationGroupId,
} from "../../../../Helpers/Chat/ChatHelper";
import {
  getMessageObjSender,
  getRecentChatMsgObj,
  blockOfflineAction,
  getMessageType,
  isAppOnline,
  getTranslateTargetLanguage
} from "../../../../Helpers/Utility";
import {
  getSenderIdFromMsgObj,
  formatUserIdToJid,
  getIdFromJid,
  getContactNameFromRoster,
  getDataFromRoster,
  // isLocalUser,
} from "../../../../Helpers/Chat/User";
import { CHAT_HISTORY_LIMIT, MEDIA_MESSAGE_TYPES } from "../../../../Helpers/Constants";
import {
  CHAT_TYPE_GROUP,
  CHAT_TYPE_SINGLE,
  UNBLOCK_CONTACT_TYPE,
} from "../../../../Helpers/Chat/Constant";
import BlockPopUp from "../PopUp/BlockPopUp.js";
import { toast } from "react-toastify";
import ActionInfoPopup from "../../../ActionInfoPopup";
import { store } from "../../../../Redux/store";
import { useSelector } from 'react-redux';
import { updateRecentChat } from "../../../../Redux/feature/recentChatDataSlice";
import { updateContactUnreadCount, updateReadStatus } from "../../../../Redux/feature/unreadCountSlice";
import { addChatConversationHistory, translateMessageAction } from "../../../../Redux/feature/chatConversationHistorySlice";
import { addPendindMedia } from "../../../../Redux/feature/pendingMediaSlice";
import { addReplyMessageData } from "../../../../Redux/feature/replyMessageDataSlice";
import { resetForwardMessage } from "../../../../Redux/feature/forwardMessageDataSlice";
import { getFromLocalStorageAndDecrypt } from "../../../../Helpers/Chat/webChatEncryptDecrypt";
import { updateMsgSeenStatus } from "../../Common/createMessage";
import { REACT_APP_GOOGLE_TRANSLATE_API_KEY } from "../../../../processENV";
import { updateBlockedContactAction } from "../PopUp/BlockAction";

const WebChatConversationHistory = (props = {}) => {
  const State = useSelector(state => state)
  const { rosterData = {},
          vCardData={},
          chatConversationHistory={},
          dynamicIcon = {},
          groupMembersData = {},selectedMessageData,blockedContact,activeChatData:{data:activeChatData = []},
          } = State;
          const { mf_BlockedIcon } = dynamicIcon?.data;
  const {
    activeChatId = "",
    activeChatData:activeData,
    forwardReset = () => { },
    avoidRecord,
  } = props;
  const { data: { participants = [] } = {} } = groupMembersData;
  const [reportData, setReportData] = React.useState({});
  const [ isBlocked , setIsBlocked ] = React.useState(false)
  const [webChatConversationHistory, setWebChatConversationHistory] =
    React.useState({
      messageData: "",
      loaderStatus: false,
      loadMoreStatus: false,
      prevMsgStatus: "",
      sendMessgeType: "",
      replyMessage: {},
      dragOnContainer: {},
      showModal: false,
      forwardOption: false,
      messageInfo: {},
      // isBlocked: false,
      addionalnfo: {},
      isVisibleScroll: false,
      showBlockModal: false,
      blockId: null,
      nameToDisplay: "",
      showReportPopup: false,
      userReplayDetails: [],
      msgActionType: "",
      isBlockedAdmin: false,
      isDeletedAccount: false,
      mediaLoder: false,
      addionalnfoMessageActionForward: {}
    });

  const {
    loaderStatus,
    sendMessgeType,
    replyMessage,
    dragOnContainer,
    showModal,
    forwardOption,
    messageInfo,
    // isBlocked,
    addionalnfo,
    showBlockModal,
    nameToDisplay,
    showReportPopup,
    userReplayDetails,
    msgActionType,
    jid,
    mediaLoder,
    selectedMsgUserName = "",
    // isBlockedAdmin,
    isDeletedAccount,
  } = webChatConversationHistory;

  React.useEffect(()=>{    
      const { data = [] } = rosterData
      let selectedUser = data.find(ele=> ele.userId === activeChatId)      
      if( selectedUser?.isDeletedUser || selectedUser?.isAdminBlocked ){
          if(showReportPopup){
            toast.error(selectedUser?.isDeletedUser ? `Cannot report deleted user's message` : `This user no longer available`)
          }
          setWebChatConversationHistory({...webChatConversationHistory,
            showReportPopup: false,
            isBlockedAdmin: selectedUser?.isAdminBlocked,
            isDeletedAccount: selectedUser?.isDeletedUser
          })
      }
      setWebChatConversationHistory({...webChatConversationHistory,
        isBlockedAdmin: selectedUser?.isAdminBlocked,
        isDeletedAccount: selectedUser?.isDeletedUser
      })  
  },[rosterData])
  React.useEffect(() => {
    const dragId = document.getElementById("msgContent");
    if (webChatConversationHistory.dragOnContainer) {
      dragId.setAttribute("draggable", false);
    }
  }, [webChatConversationHistory.dragOnContainer]);
  React.useEffect(()=>{
      handleBlockUserData()
  },[])

  React.useEffect(()=>{
    handleBlockUserData();
  },[blockedContact?.id])

  let activeTimer = 0;
  const rosterConst = "roster.userId";
  const rosterGrpIdConst = "roster.groupId";
  const loadMore = React.useRef();
  const browserTabData = useSelector((state)=>state.browserTab.data)

  const reportChatAction = (show = false) => {
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      showReportPopup: show,
    });
  };

  const handleBlockUserData = () => {
    const { roster, recent } = props.activeChatData;
    const detail = roster && Object.keys(roster).length > 0 ? roster : recent;
    const jid = formatUserIdToJid(detail.userId);
    if (!jid) return false;
    let blockedContactArr = blockedContact.data;
    const isBlocked = blockedContactArr.indexOf(jid) > -1;
    setIsBlocked( isBlocked );
  };


  const reportConfirmAction = async(event) => {
    const getReportData = reportData    
    if(event.detail <= 1){
      if (blockOfflineAction()) return;
      const { activeChatData:{ chatId = "" } } = props;
      const { msgId = "" } = getReportData;
      const getChatJid = formatUserIdToJid(chatId,chatType)
      const reportDatas = getMessagesForReport(activeChatId, msgId)
      if(reportDatas.length === 0){
        toast.error(`No Messages To Report`)
        reportChatAction(false);
      }else{
        await SDK.reportUserOrGroup(getChatJid,chatType,reportDatas)
        toast.success(`Report sent`);
        reportChatAction(false);
    }
    }
  }

  React.useEffect(()=>{
    const chatTypeUseEffect = activeData?.chatType;
    requestChatMessages(chatTypeUseEffect);
    return () => {
        clearTimeout(activeTimer);
    };
  },[])

  React.useEffect(()=>{
    const chatType = activeChatData[0].chatType;
    requestChatMessages(chatType);
  },[activeChatData, activeData])

  React.useEffect(() => {
    handleBlockUserData();
    props.messageInfoShow(false);
    const { activeChatData:{ chatId = "" } } = props;
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      jid: chatId,
    });
    const conversationHistoryData = chatConversationHistory.data;
    if (!Object.keys(conversationHistoryData).includes(activeData.chatId)) {
      /**
       *  this.setState({ jid: chatId, loaderStatus: true, forwardOption: false });
      */ 
        requestChatMessages(chatType);
    } else {
      updateMsgSeenStatus();
    }
  },[activeChatId]);

  React.useEffect(()=>{
    store.dispatch(updateReadStatus(activeChatId))
    const { activeChatData:{ chatId = "" } } = props;
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      jid: chatId,
    });
    // sentSeenStatus()
  },[chatConversationHistory?.id])

  React.useEffect(()=>{
    updateMsgSeenStatus();
  },[browserTabData])
  
  /**
  // const sentSeenStatus=()=>{
  //   const { data:chatConversation }= chatConversationHistory
  //   console.log(store.getState()?.unreadCountData,"unreadCountData")
  //   const activeChatMessages = chatConversation[activeChatId]?.messages
  //   if(activeChatMessages){
  //     Object.entries(activeChatMessages).map(item => {
  //       if(item[1].msgStatus !== 2){
  //           console.log(item,"activeChatMessages")
  //           let msgUserId = isSingleChat(item[1].chatType) ? item[1].fromUserId : item[1].publisherId
  //           let composerId = !isLocalUser(msgUserId) ? msgUserId : null
  //           let unseenMsgId = item[1].msgId
  //           let groupId = isSingleChat(item[1].chatType) ? "" : item[1].fromUserId
  //           composerId && SDK.sendSeenStatus(formatUserIdToJid(composerId), unseenMsgId, groupId);
  //         }
  //       })
  //     }
  // }
  */
  
  const requestChatMessages = async (
    chatTypeReq,
    direction = null,
    limit = CHAT_HISTORY_LIMIT,
    rowId = null
  ) => {
    if (isSingleOrGroupChat(chatTypeReq)) {
      let chatJid = getActiveConversationUserJid(),
        activeConversationId = getActiveConversationChatId();
      if (!chatJid) return true;
      const chatMessageRes = await SDK.getChatMessages(
        chatJid,
        direction,
        rowId,
        limit
      );
      if (chatMessageRes && chatMessageRes.statusCode === 200) {
        chatMessageRes.chatType = chatTypeReq;
        chatMessageRes.fetchLimit = limit;
        delete chatMessageRes.statusCode;
        delete chatMessageRes.message;
        if (
          activeConversationId ===
          getIdFromJid(chatMessageRes.userJid || chatMessageRes.groupJid)
        ) {
          store.dispatch(addChatConversationHistory(chatMessageRes));
        }
      }
      return true;
    }
    return false;
  };

  const requestReplyMessage = (grmsgid, replyTo, chat_Type) => {	
    if (isAppOnline()) {	
      SDK.getReplyMessage(replyTo, chat_Type);	
    } else {	
      // When user try to reply in offline, at this time get the message	
      // details from the local message history & set that message as reply message	
      const message = getActiveConversationMessageByMsgId(replyTo, chat_Type);	
      const replyMsgDetails = getReplyMessageFormat(message);	
      if (replyMsgDetails) {	
        store.dispatch(addReplyMessageData(replyMsgDetails));	
      }	
    }	
  };

  const onScrolledTop = async () => {
    const  { data } = chatConversationHistory
    const chatId = activeChatId; 
    if (data[chatId]) {
      const { messages: currentChatHistory, isScrollNeeded } = data[chatId];
      if (isScrollNeeded) {
        loadMoreUpdate(true);
        const firstMessageId = Object.keys(currentChatHistory)[0];
        const firstMessageData = currentChatHistory[firstMessageId];
        await requestChatMessages(
          chatType,
          "up",
          // firstMessageId,
          CHAT_HISTORY_LIMIT,
          firstMessageData.rowId
        );
        loadMoreUpdate(false);
      }
    }
  };

  const onScrolled = (event) => {
    const { target } = event;
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight - 20) {
      setWebChatConversationHistory({
        ...webChatConversationHistory,
        isVisibleScroll: false,
      });
    } else {
      setWebChatConversationHistory({
        ...webChatConversationHistory,
        isVisibleScroll: true,
      });
    }
  };
  const onScrolledBottom = () => { };

  /**
  // useEffect(() => {
  //   return () => {
  //     clearTimeout(activeTimer);
  //   };
  // }, []);
  */

  const smoothScroll = (elementId) => {
    const container = document.getElementById(elementId);
    if (!container) return;
    container.scrollIntoView();
    container.classList.add("animatefinded");
    activeTimer = setTimeout(() => {
      container.classList.remove("animatefinded");
    }, 3000);
  };

  // Show button when page is scorlled upto given distance
  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToBottom = () => {
    window.document &&
      document.getElementById("InBottom").scrollIntoView({ block: "end" });
  };

  const viewOriginalMessage = async (messageId, msgId) => {
    const chatMessagesViewOriginalMessage = getActiveChatMessages();
    const isExist = chatMessagesViewOriginalMessage.find((message) => message.msgId === messageId);
    if (isExist) {
      smoothScroll(messageId);
      return;
    }
    if (chatMessagesViewOriginalMessage.length) {
      loadMoreUpdate(true);
      setTimeout(() => {
        loadMoreUpdate(false);
        viewOriginalMessage(messageId, msgId);
      }, 100);
    }
  };

  const prepareJid = () => {
    const jidPrepared = activeData?.chatId;
    return formatUserIdToJid(jidPrepared,activeData?.chatType);
  };

  const deleteMessageFromConversation = (deleteType) => (event) => {
    if (blockOfflineAction()) return;
    const {
      selectedMessageData: { data = [] },
    } = State;
    let msgIds = data.slice().sort((a, b) => (b.timestamp > a.timestamp ? -1 : 1)).map((el) => el.msgId);
    const jidData = prepareJid();

    store.dispatch(resetForwardMessage())
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      showModal: false,
      replyMessage: {}
    });
    if (deleteType === 1) {
      SDK.deleteMessagesForMe(jidData, msgIds);
    } else {
      SDK.deleteMessagesForEveryone(jidData, msgIds);
    }
    toast.success(`${msgIds.length} message${msgIds.length > 1 ? "s" : ""} deleted`);

    setWebChatConversationHistory({
      ...webChatConversationHistory,
      forwardOption: false,
      showModal: false,
      addionalnfo: {
        ...addionalnfo,
        forward: false,
      },
    });
  };

  const deleteMultipleMessages = () => {
    if (blockOfflineAction()) return;
    const {
      selectedMessageData: { data },
    } = State;
    let msgIds = data.slice().sort((a, b) => (b.timestamp > a.timestamp ? -1 : 1)).map((el) => el.msgId);
    let lastMsgIndex = data.findIndex((obj) => obj.msgId === msgIds[0]);
    let lastMsgTime = parseInt(data[lastMsgIndex].timestamp / 1000);
    const now = new Date().getTime();
    const validTime = lastMsgTime + 30 * 1000;

    setWebChatConversationHistory({
      ...webChatConversationHistory,
      showModal: true,
      replyMessage: {
        ...replyMessage,
        deleteEveryOne: validTime > now,
      },
    });
  };

  const handleShowMessageinfo = () => {
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      messageInfo: {},
    });
    props.messageInfoShow(!props.showMessageinfo);
  };

  const handleStarredAction = async () => {
    if (blockOfflineAction()) return;
    const {
      selectedMessageData: { data },
    } = props;

    let isFavourite = false;

    /**
    // const msgIds = data.map((el) => {
    //   if (el.favouriteStatus === 0) {
    //     isFavourite = true;
    //   }
    //   return el.msgId;
    // });

    // await SDK.updateFavouriteStatus(formatUserIdToJid(props.activeChatId), msgIds, isFavourite);
    */
    toast.success(
      `${data.length} message${data.length > 1 ? "s" : ""} ${isFavourite ? "starred" : "unstarred"
      }`
    );
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      forwardOption: false,
    });
    forwardReset();
  };

  const messageAction = async (event, selectedMessage, nameToDisplayMessageAction) => {
    const targetElement = event.target || event.srcElement;
    const { deleteStatusMessageAction, msgId } = selectedMessage;
    const senderId = getSenderIdFromMsgObj(selectedMessage);

    if (targetElement.tagName === "UL") return;
    const optionType = targetElement.closest("li").getAttribute("title");
    const { fromUser } = State?.vCardData?.data;
    const isSenderMessageAction = senderId && senderId.indexOf(fromUser) !== -1;

    if (optionType === "Reply") {
      const {
        activeChatData: { data = {} },
      } = State;
      const reMovedata = [...userReplayDetails];
      const reMoveEle = (reMovedata || []).filter(
        (ele) =>
          _get(ele, rosterConst, null) !== _get(data[0], rosterConst, undefined) &&
          _get(ele, rosterGrpIdConst, null) !== _get(data[0], rosterGrpIdConst, undefined)
      );
      const newObjData = {
        replyMessages: {
          ...selectedMessage,
        },
      };
      const newObj = { ...newObjData, ...data[0] };
      const newArr = [...reMoveEle, newObj];
      setWebChatConversationHistory({ 	
        ...webChatConversationHistory, 	
        userReplayDetails: newArr,	
        sendMessgeType: optionType,	
        replyMessage: {	
          ...selectedMessage,	
          nameToDisplay: nameToDisplayMessageAction || "",	
        },	
      });	
      return;	
    }

    if (optionType === "Delete") {
      if (blockOfflineAction()) return;
      props.messageInfoShow(false);
      setWebChatConversationHistory({
        ...webChatConversationHistory,
        msgActionType: "Delete",
        forwardOption: true,
        addionalnfo: {
          ...addionalnfo,
          forward: true,
          forwardMessageId: msgId,
          deleteAction: true,
        },
        replyMessage: {
          ...selectedMessage,
          isSender: isSenderMessageAction,
          messageInfo: {},
          recallstatus: deleteStatusMessageAction,
        },
      });
      return;
    }

    if (optionType === "MessageInfo") {
      if (blockOfflineAction()) return;
      props.messageInfoShow(true);
      /**
       // let jidMsgInfo = prepareJid();
      // const { msgId: messageId } = messageInfo;
      // console.log("messageInfo",messageInfo)
      // messageInfoAction({ statusUpdate: false, messageId }, true);
      // messageId && SDK.getGroupMsgInfo(jidMsgInfo, messageId);
      */

      setWebChatConversationHistory(
        {
          ...webChatConversationHistory,
          forwardOption: false,
          messageInfo: {
            ...selectedMessage,
            isSender: isSenderMessageAction,
            forward: false,
          },
        })
        
          let jidMsgInfo = prepareJid();
          const { msgId: messageId } = selectedMessage;
          messageInfoAction({ statusUpdate: false, messageId }, true);
          messageId && SDK.getGroupMsgInfo(jidMsgInfo, messageId);

          
      return;
    }

    if (optionType === "Forward") {
      const recordingStatus = getFromLocalStorageAndDecrypt("recordingStatus");
      if(!recordingStatus){
        toast.error("You are on Audio Recording ")
        return
      }  
      props.messageInfoShow(false);
      setWebChatConversationHistory({
        ...webChatConversationHistory,
        msgActionType: "Forward",
        forwardOption: true,
        addionalnfo: {
          ...addionalnfo,
          forward: true,
          forwardMessageId: msgId,
          deleteAction: false,
        },
      });
      return;
    }

    if (optionType === "Report") {
      if (isDeletedAccount || isBlockedAdmin) {
        toast.error(
          isDeletedUser
            ? `Cannot report deleted user's message`
            : `This user no longer available`
        );
        return;
      }
      if (
        getDataFromRoster(activeChatId)?.isDeletedUser ||
        getDataFromRoster(activeChatId)?.isAdminBlocked
      ) {
        toast.error(
          getDataFromRoster(props?.activeChatId)?.isDeletedUser
            ? `Cannot report deleted user's message`
            : `This user no longer available`
        );
        return;
      }
      setReportData(selectedMessage);
      reportChatAction(true);
      return;
    }

    if (optionType === "Starred" || optionType === "UnStarred") {
      if (blockOfflineAction()) return;
      const { addionalnfoStarred } = state;
      props.messageInfoShow(false);
      setWebChatConversationHistory({
        ...webChatConversationHistory,
        msgActionType: optionType,
        forwardOption: true,
        addionalnfo: {
          ...addionalnfoStarred,
          forward: true,
          forwardMessageId: msgId,
          deleteAction: false,
        },
        replyMessage: {
          ...selectedMessage,
          isSender: isSenderMessageAction,
          messageInfo: {},
          recallstatus: deleteStatusMessageAction,
        },
      });
      return;
    }

    if (optionType === "Download") {
      const {
        msgBody: {
          media: { file_url, fileName: file_name, file_key } = {},
          message_type = "",
        } = {},
      } = selectedMessage;
      const fileName = message_type === "file" ? file_name : "";
      downloadMediaFile(file_url, message_type, fileName, file_key);
      return;
    }
    if (optionType === "Copy") {
      const {
        msgBody: {
          message_type,
          message:copyMessage,
          media = {}
        } = {},
      } = selectedMessage;
      const copyMessages = MEDIA_MESSAGE_TYPES.includes(message_type) ? media?.caption : copyMessage;
      copyToClipboard(copyMessages)
      toast.success("Message Copied Sucessfully")
      return;
    }
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      sendMessgeType: optionType,
      replyMessage: {
        ...selectedMessage,
        nameToDisplay: nameToDisplayMessageAction || "",
      },
    });
  };

  const handleTranslateLanguage = async (msgIdLang, replyMessageLang) => {
    if (blockOfflineAction()) return;
    const { msgBody: { message = "", message_type = "", media: { caption = "" } = {} } = {} } = replyMessageLang;
    const text = isTextMessage(message_type) ? message : caption;
    if (text) {
      const target = getTranslateTargetLanguage();
      const translateResult = await SDK.translateText(REACT_APP_GOOGLE_TRANSLATE_API_KEY, text, target);
      if (translateResult.statusCode === 200 && translateResult.data?.translations.length > 0) {
        const dispatchData = {
          fromUserId: activeChatId,
          msgId: msgIdLang,
          translatedMessage: translateResult.data?.translations[0].translatedText || ""
        };
        store.dispatch(translateMessageAction(dispatchData));
      }
    }
  };

  const closeReplyAction = (userId = "") => {
    const replyData = [...userReplayDetails];
    const reMoveEle = replyData.filter(
      (ele) =>
        _get(ele, rosterConst, null) !== userId &&
        _get(ele, rosterGrpIdConst, null) !== userId
    );
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      sendMessgeType: reMoveEle.length !== 0 ? "Reply" : "",
      replyMessage: {},
      showModal: false,
      userReplayDetails: reMoveEle,
    });
  };

  const sendMediaMessage = async (messageType, files, chatTypeSendMsg) => {
    let jidSendMediaMessage= prepareJid();
    const jids = getIdFromJid(jidSendMediaMessage);
    sendMessgeType && closeReplyAction(jids);
    if (messageType === "media") {
      let mediaData = {};

        // For Local Render Process - Needs to be Handled with "Asynchronous"
        for (let i = 0; i < files.length; i++) {
          const file = files[i],
            msgId = uuidv4();
          const { caption = "", fileDetails: { replyTo, duration = 0, imageUrl = "", audioType = "" } = {} } = file;
          let fileOptions = {
            fileName: file.name,
            fileSize: file.size,
            caption: caption,
            blobUrl: URL.createObjectURL(file),
            msgId: msgId,
            duration: duration,
            audioType
          };

          const msgType = getMessageType(file.type, file);
          if (msgType === "video" || msgType === "audio") fileOptions.thumbImage = imageUrl;
          const userProfile = vCardData;

          const dataObj = {
            jid:jidSendMediaMessage,
            msgType,
            userProfile,
            chatType:chatTypeSendMsg,
            msgId,
            file,
            fileOptions,
            replyTo,
            fileDetails: file.fileDetails
          };
          const conversationChatObj = await getMessageObjSender(dataObj, i);
          mediaData[msgId] = conversationChatObj;
          const recentChatObj = getRecentChatMsgObj(dataObj);

          const dispatchData = {
            data: [conversationChatObj],
            ...(isSingleChat(chatTypeSendMsg) ? { userJid: jidSendMediaMessage } : { groupJid: jidSendMediaMessage })
          };
          store.dispatch(addChatConversationHistory(dispatchData));
          store.dispatch(updateRecentChat(recentChatObj));
          store.dispatch(addPendindMedia(dispatchData));
        }
        /**
        // handleTempArchivedChats(jid, chatTypeSendMsg);
        */
        setTimeout(() => {
          scrollToBottom()
          });
  }
  return false;
};

  const replyToIdPass = (jidRply = "") => {
    if (userReplayDetails.length !== 0) {
      const replyData = [...userReplayDetails];
      const findUserMsgId = replyData.find(
        (ele) => _get(ele, rosterConst, "") === jidRply || _get(ele, rosterGrpIdConst, "") === jidRply
      );
      return _get(findUserMsgId, "replyMessages.msgId", "");
    }
    return "";
  };

  const parseAndSendMessage = async (message, chatTypeParse, messageType) => {
    const jidParse = prepareJid();
    const jidsParse = getIdFromJid(jidParse);
    const { content } = message;
    const replyTo = sendMessgeType ? replyToIdPass(jidsParse) : "";
    content[0].fileDetails.replyTo = replyTo;
    sendMediaMessage(messageType, content, chatTypeParse);
  };

  const msgReplyPassId = () => {
    let findJid = prepareJid();
    const jids = getIdFromJid(findJid);
    /**
    // const { sendMessgeType = "", userReplayDetails = [] } = this.state;
    */
    if (sendMessgeType === "Reply") {
      const findUserMsgId = userReplayDetails.find(
        (ele) => _get(ele, rosterConst, "") === jids || _get(ele, rosterGrpIdConst, "") === jids
      );
      return _get(findUserMsgId, "replyMessages.msgId", "");
    }
    return sendMessgeType ? replyMessage.msgId : "";
  };

  const handleSendMsg = async (message) => {
    let messageType = message.type;
    let chatTypeMSgSend = activeData?.chatType;
    const replyTo = msgReplyPassId();
    const userProfile = vCardData;

    if (messageType === "media") {
      parseAndSendMessage(message, chatTypeMSgSend, messageType);
      return;
    }

    if (message.content !== "") {
      let jidSendMsg = prepareJid();
      const jids = getIdFromJid(jidSendMsg);
      let msgId = uuidv4();
      if (chatTypeMSgSend === CHAT_TYPE_SINGLE || chatTypeMSgSend === CHAT_TYPE_GROUP) {
        const dataObj = {
          jid : jidSendMsg,
          msgType: "text",
          message: message.content,
          userProfile,
          chatType:chatTypeMSgSend,
          msgId,
          replyTo
        };
        const conversationChatObj = await getMessageObjSender(dataObj);
        const recentChatObj = getRecentChatMsgObj(dataObj);
      await SDK.sendTextMessage(
          jidSendMsg,
          message.content,
          msgId,
          replyTo
        )
        await SDK.sendTypingGoneStatus(jidSendMsg);
        const dispatchData = {
          data: [conversationChatObj],
          ...(isSingleChat(chatTypeMSgSend) ? { userJid: jidSendMsg } : { groupJid: jidSendMsg }),
        };
        store.dispatch(addChatConversationHistory(dispatchData));
        store.dispatch(updateRecentChat(recentChatObj));
        const unreadCountArray = {
          fromUserId : activeData?.chatId,
          unreadCount:0
        }
      store.dispatch(updateContactUnreadCount(unreadCountArray))
      sendMessgeType && closeReplyAction(jids);
      }
    }
    setTimeout(() => {
      scrollToBottom()         
    });
  };

  const closeMessageOption = (forward = null) => {
    setWebChatConversationHistory(
      {
        ...webChatConversationHistory,
        forwardOption: false,
        addionalnfo: {
          ...addionalnfo,
          forward: false,
        },
      }
    );
    store.dispatch(resetForwardMessage());
  };

  const canSendMessage = () => {
    const chatTypeData = activeData?.recent?.chatType;
    /**
    // if (chatType === "broadcast") {
    //   return true;
    // }
    */
    if (chatTypeData === "chat") {
      return !isBlocked;
    }
    const fromUser = vCardData?.data?.fromUser;
    return participants.find((profile) => {
      return fromUser === profile.userId && profile.userType;
    });
  };

  const onDragEnter = (event) => {
    if (event.dataTransfer.types) {
      for (const element of event.dataTransfer.types) {
        if (element === "Files") {
          const dragId = document.getElementById("msgContent");
          dragId.setAttribute("draggable", true);
          setWebChatConversationHistory(
            {
              ...webChatConversationHistory,
              dragOnContainer: {
                status: true,
                draggedId: uuidv4(),
              },
            },
            // () => {
            //   dragId.setAttribute("draggable", false);
            // }
          );
        }
      }
      /**
      for (let i = 0; i < event.dataTransfer.types.length; i++) {
        if (event.dataTransfer.types[i] === "Files") {
          const dragId = document.getElementById("msgContent");
          dragId.setAttribute("draggable", true);
          setWebChatConversationHistory(
            {
              ...webChatConversationHistory,
              dragOnContainer: {
                status: true,
                draggedId: uuidv4(),
              },
            },
            () => {
              dragId.setAttribute("draggable", false);
            }
          );
        }
      }
       */
    }
    return false;
  };


  const dispatchAction = async () => {
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      showBlockModal: false,
    });
    const userJid = formatUserIdToJid(webChatConversationHistory.blockId);
    const res = await SDK.unblockUser(userJid);
    if (res && res.statusCode === 200) {
      toast.success(`${webChatConversationHistory.nameToDisplay || "User"} has been Unblocked`);
      updateBlockedContactAction(userJid, UNBLOCK_CONTACT_TYPE);
      /**
      // handleTempArchivedChats(userJid, CHAT_TYPE_SINGLE);
      */
    }
  };

  const popUpToggleAction = (userJid) => {
    const { activeChatData: { roster } = {} } = props;
    setWebChatConversationHistory({
      ...webChatConversationHistory,
      showBlockModal: !showBlockModal,
      blockId: userJid ? userJid : null,
      nameToDisplay: getContactNameFromRoster(roster),
    });
  };

  const loadMoreUpdate = (value) => {
    loadMore.current.style.display = value ? "block" : "none";
    return true;
  };

  const style = { width: 50, height: 50 };
  const loadMoreStyle = { width: 50, height: 50, display: "none" };

  const {
    groupMemberDetails,
    showMessageinfo = false,
  } = props;
  const chatType = activeData?.chatType
  const lastServerMessage = props?.messageData;
  const groupNickName = props?.activeChatData?.roster?.nickName;
  const {
    deleteStatus,
    deleteEveryOne = null,
    isSender = null,
  } = replyMessage || {};
  const chatMessages = getChatMessageHistoryById(activeChatId);
  let isBlockedAdmins = getDataFromRoster(jid) || {};
  let getBlockedAdmin = isBlockedAdmins.isAdminBlocked
  let isBlockedAdmin = webChatConversationHistory.isBlockedAdmin === 0 || !getBlockedAdmin ? false : true;
  return (
    <Fragment>
      {showBlockModal && (
        <Modal containerId="container">
          <BlockPopUp
            popUpToggleAction={popUpToggleAction}
            dispatchAction={dispatchAction}
            headerLabel={
              <>
                {"Unblock"} {nameToDisplay} ?
              </>
            }
            closeLabel={"Cancel"}
            actionLabel={"Unblock"}
            infoLabel={
              "On unblocking, this contact will be able to call you or send messages to you."
            }
          />
        </Modal>
      )}
      <div className={`chatconversation-container`}>
        <div onDragEnter={onDragEnter} id="msgContent" className="msg-content">
          <div className="loader">
            {loaderStatus && (
              <img src={loaderSVG} alt="message-history" style={style} />
            )}
            <img
              src={loaderSVG}
              alt="load-history"
              ref={loadMore}
              style={loadMoreStyle}
            />
          </div>
          {/* {isSingleOrGroupChat(chatType) && !loaderStatus && ( */}
            <ChatTemplate
              chatmessages={chatMessages}
              rosterData={rosterData}
              groupMemberDetails={groupMemberDetails}
              vCardData={vCardData}
              onScrolledTop={onScrolledTop}
              onScrolledBottom={onScrolledBottom}
              closeMessageOption={closeMessageOption}
              messageAction={messageAction}
              requestReplyMessage={requestReplyMessage}
              viewOriginalMessage={viewOriginalMessage}
              groupNickName={groupNickName}
              jid={activeData.chatId}
              addionalnfo={addionalnfo}
              deliveredType={lastServerMessage}
              chatType={chatType}
              onScrolled={onScrolled}
              scrollToBottom={scrollToBottom}
              handleTranslateLanguage={handleTranslateLanguage}
              handleShowCallScreen={props.handleShowCallScreen}
              handleMediaShow={props.handleMediaShow}
            />
          {/* )} */}

        </div>

        {isBlocked && isSingleChat(chatType) && !getBlockedAdmin && (
          <div className="blockedContainer">
            <p>
              <i>
              
              <CustomIcon
                icon={mf_BlockedIcon ? mf_BlockedIcon : <BlockedIconHoc viewBox="0 0 18 18"/>}
                {...props}
            /> 
              </i>{" "}
              <span>
                {`You can't send message to this blocked contact.`}
                <span
                  className="link"
                  onClick={() => {
                    popUpToggleAction(jid);
                  }}
                >
                  Unblock
                </span>
              </span>
            </p>
          </div>
        )}
        {isSingleChat(chatType) && getBlockedAdmin && (
          <div className="blockedUserContainer">
            <p>This user is no longer available</p>
          </div>
        )}
        {forwardOption && (
          <ForwardOptions
            msgActionType={msgActionType}
            activeJid={activeData.chatId}
            closeMessageOption={closeMessageOption}
            deleteMultipleMessages={deleteMultipleMessages}
            handleStarredAction={handleStarredAction}
            scrollToBottom={scrollToBottom}
          />
        )}
        {showModal && (
          <Modal containerId="container">
            <div className="popup-wrapper deleteMessage">
              <div className="popup-container">
                <div className="popup-container-inner">
                  <div className="popup-label">
                    <label>
                      Are you sure you want to delete selected message
                      {selectedMessageData?.data?.length > 1 ? "s" : ""}?
                    </label>
                  </div>
                  <div className="popup-noteinfo">
                    {deleteStatus === 0 && isSender && deleteEveryOne ? (
                      <Fragment>
                        <button
                          type="button"
                          onClick={deleteMessageFromConversation(1)}
                          className="btn-cancel danger"
                        >
                          Delete For Me
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setWebChatConversationHistory({
                              ...webChatConversationHistory,
                              showModal: false,
                            })
                          }
                          className="btn-cancel"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={deleteMessageFromConversation(2)}
                          className="btn-active danger"
                        >
                          Delete For Everyone
                        </button>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <button
                          type="button"
                          onClick={() =>
                            setWebChatConversationHistory({
                              ...webChatConversationHistory,
                              showModal: false,
                            })
                          }
                          className="btn-cancel"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={deleteMessageFromConversation(1)}
                          className="btn-active danger"
                        >
                          Delete For Me
                        </button>
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        )}
        {showMessageinfo && (
          <Modal divclass="messageInfo" containerId="container">
            <MessageInfo
              groupMemberDetails={groupMemberDetails}
              vCardData={vCardData}
              messageAction={messageAction}
              requestReplyMessage={requestReplyMessage}
              viewOriginalMessage={viewOriginalMessage}
              groupNickName={groupNickName}
              jid={jid}
              addionalnfo={{
                ...addionalnfo,
                messageInfo: true,
              }}
              msg={messageInfo}
              chatType={chatType}
              rosterData={rosterData}
              handleShowMessageinfo={handleShowMessageinfo}
              closeMessageOption={closeMessageOption}
            />
          </Modal>
        )}
        {canSendMessage() && !getBlockedAdmin &&(
          <WebChatMessagesComposing
            forwardOption={forwardOption}
            loaderStatus={false}
            dragOnContainer={dragOnContainer}
            handleSendMsg={handleSendMsg}
            jid={activeChatId}
            chatType={chatType}
            replyMessage={replyMessage}
            sendMessgeType={sendMessgeType}
            vCardData={props.vCardData}
            rosterData={rosterData?.data}
            closeReplyAction={closeReplyAction}
            groupMemberDetails={groupMemberDetails}
            userReplayDetails={userReplayDetails}
            avoidRecord={avoidRecord}
          />
        )}
        <div className={`${mediaLoder ? "conversation-overlay" : ""}`}>
          {mediaLoder && (
            <img src={loaderSVG} alt="message-history" style={style} />
          )}
        </div>
      </div>
      {showReportPopup && (
        <ActionInfoPopup
          textActionBtn={"Report"}
          btnActionClass={"red"}
          textCancelBtn={"Cancel"}
          textHeading={`Report  ${isSingleChat(chatType) ? groupNickName : ""}
          ${isGroupChat(chatType) ? selectedMsgUserName : ""}?`}
          handleAction={(e) => reportConfirmAction(e)}
          handleCancel={() =>
            setWebChatConversationHistory({
              ...webChatConversationHistory,
              showReportPopup: false,
            })
          }
          textInfo={<><span>This message will be forwarded to admin.<br></br>This contact will not be notified.</span></>}
        />
      )}
    </Fragment>
  );
};

export default WebChatConversationHistory;
